import { render } from "./module-type-picker-dialog.vue?vue&type=template&id=5c92f07a"
import script from "./module-type-picker-dialog.vue?vue&type=script&lang=js"
export * from "./module-type-picker-dialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__